import type { TCourse, TCourses } from './types';

type TSortOrder = 'ASC' | 'DESC';

const sortAlphabeticallyAsc = (a: string, b: string) => {
  return a.localeCompare(b, 'en', { sensitivity: 'base' });
};
const sortAlphabeticallyDesc = (a: string, b: string) => {
  const sortedAscending = sortAlphabeticallyAsc(a, b);
  return sortedAscending === 0 ? sortedAscending : sortedAscending * -1;
};

const sortByNameAsc = (a: TCourse, b: TCourse) => {
  if (!a.polName || !b.polName) {
    return 0;
  }
  return sortAlphabeticallyAsc(a.polName, b.polName);
};
const sortByNameDesc = (a: TCourse, b: TCourse) => {
  if (!a.polName || !b.polName) {
    return 0;
  }
  return sortAlphabeticallyDesc(a.polName, b.polName);
};

const sortCourses = (courses: TCourses, sortBy: TSortOrder): TCourses => {
  if (sortBy === 'ASC') {
    const sorted = courses.sort(sortByNameAsc);
    return sorted;
  }
  if (sortBy === 'DESC') {
    const sorted = courses.sort(sortByNameDesc);
    return sorted;
  }
  return courses;
};

export {
  type TSortOrder,
  sortCourses,
  sortAlphabeticallyAsc,
  sortAlphabeticallyDesc
};
